import React from 'react'
import styled from 'styled-components'
import VisaIcon from '../../custom-icons/visa-icon.component'
import cardBrand from '../../../constants/card-brand.constants'
import PureSelect from '../pure-select.component'
import RadioButton from '../radio-button.component'
import MasterCardIcon from '../../custom-icons/master-card-icon.component'
import { connect } from 'react-redux'
import { breakpoints } from '../../../constants'
import { StyledContent } from '../payment-fields/styled-content.style'
import { StyledCardFields } from '../payment-fields/styled-card-fields.style'
import { Creators as DebitCardPurchaseCreators } from '../../../ducks/debit-card-purchase/debit-card-purchase'
import {
	AmexCreditCardInput,
	DebitCardInput,
	SecurityCodeInput,
	TextInput
} from '../inputs.component'

const StyledPaymentMethodsButtons = styled.div`
	display: flex;
	flex-wrap: nowrap;

	& > div {
		flex-grow: 1;
		padding: 8px;

		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			flex-grow: initial;
			padding: 15px;
		}

		img {
			max-width: 30px;

			@media screen and (min-width: ${breakpoints.MOBILE}px) {
				max-width: 100%;
			}
		}
	}
`

const StyledFieldsContainer = styled.div`
	.validity-field {
		${({ noSecurityCode }) => noSecurityCode && 'grid-column: 1 / 3'};
	}

	.validity-field:last-child {
		${({ noSecurityCode }) => noSecurityCode && 'grid-column: 3 / 5'};
	}
`

const cardYearValidityOptions = (function() {
	let options = []
	let currentYear = new Date().getFullYear()
	const yearsRange = 11

	for (let i = 0; i <= yearsRange; i++)
		options.push({
			value: currentYear - 2000,
			label: currentYear++
		})

	return options
})()

class DebitCardFields extends React.PureComponent {
	constructor(props) {
		super(props)
		this.state = {
			selectedCardBrand: this.props.values.cardBrand || cardBrand.mastercard
		}
	}

	selectCardBrand = value => {
		this.props.setCardBrand(value)
		this.props.setFieldValue('cardBrand', value)
		this.setState({ selectedCardBrand: value })
	}

	recurrentPayDayOptions = [
		{ value: 5, label: '5' },
		{ value: 15, label: '15' },
		{ value: 25, label: '25' }
	]

	renderDebitCardInput = () => {
		return (
			<DebitCardInput
				{...this.props}
				id="cardNumber"
				className="cardNumber"
				label="Número do cartão"
				onComplete={debitCardNumber =>
					this.props.setDebitCardNumber(debitCardNumber)
				}
			/>
		)
	}

	render() {
		const { selectedCardBrand } = this.state
		const { noSecurityCode } = this.props

		return (
			<React.Fragment>
				<p className="blue">Informações do cartão</p>
				<StyledPaymentMethodsButtons isCardBrands>
					<RadioButton
						isActive={selectedCardBrand == cardBrand.mastercard}
						onClick={() => this.selectCardBrand(cardBrand.mastercard)}>
						<StyledContent>
							<MasterCardIcon
								disabled={selectedCardBrand !== cardBrand.mastercard}
							/>
						</StyledContent>
					</RadioButton>
					<RadioButton
						isActive={selectedCardBrand == cardBrand.visa}
						onClick={() => this.selectCardBrand(cardBrand.visa)}>
						<StyledContent>
							<VisaIcon
								disabled={selectedCardBrand !== cardBrand.visa}
							/>
						</StyledContent>
					</RadioButton>
				</StyledPaymentMethodsButtons>
				<StyledFieldsContainer noSecurityCode={noSecurityCode}>
					<StyledCardFields
						style={
							noSecurityCode && { gridTemplateColumns: 'repeat(4, 1fr)' }
						}>
						{this.renderDebitCardInput()}
						<PureSelect
							id="cardMonthValidity"
							className="card-month-validity validity-field"
							label="Validade"
							placeholder="Mês"
							options={[
								{ value: '01', label: '01' },
								{ value: '02', label: '02' },
								{ value: '03', label: '03' },
								{ value: '04', label: '04' },
								{ value: '05', label: '05' },
								{ value: '06', label: '06' },
								{ value: '07', label: '07' },
								{ value: '08', label: '08' },
								{ value: '09', label: '09' },
								{ value: '10', label: '10' },
								{ value: '11', label: '11' },
								{ value: '12', label: '12' }
							]}
							{...this.props}
						/>
						<PureSelect
							id="cardYearValidity"
							className="card-year-validity validity-field"
							placeholder="Ano"
							options={cardYearValidityOptions}
							{...this.props}
						/>
						{noSecurityCode || (
							<SecurityCodeInput
								id="securityCode"
								className="security-code"
								label="Cód. de segurança"
								maxLength={4}
								{...this.props}
							/>
						)}
					</StyledCardFields>
				</StyledFieldsContainer>
			</React.Fragment>
		)
	}
}

const mapStateToProps = ({ debitCardPurchase }) => ({
	cardBrand: debitCardPurchase.cardBrand,
	debitCardNumber: debitCardPurchase.debitCardNumber
})
const mapDispatchToProps = {
	setCardBrand: DebitCardPurchaseCreators.setCardBrand,
	setDebitCardNumber: DebitCardPurchaseCreators.setDebitCardNumber
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(DebitCardFields)
